import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de76d586546b63/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de76d586546b63/node_modules/next/dist/client/link.js");
